// fetch
import { getWithToken } from './fetch.js';

// urls
import urls from './_services.json';

// util
import { getUrl, obsuscator } from './util.js';

/**
 * getOssToken
 * @param {*} bizCode 0生图，模版工具，专业工具，1社区，2训练
 */
export async function getOssToken(bizCode, isUs = false) {
  const _url = isUs ? urls.getOssTokenV2 : urls.getOssToken;

  // 这里的接口地址使用了新地址
  // 目的是为了解决oss token权限过大的漏洞
  // 详见：https://alidocs.dingtalk.com/i/nodes/1zknDm0WRLPvpZv2trm2ZOZZJBQEx5rG?utm_scene=team_space
  const url = getUrl(_url + `/${bizCode}`);

  // get
  const token = await getWithToken(url);

  if (!isUs) {
    // 海外的逻辑保持不变
    const tokenData = token.data;
    let tokenRes = obsuscator(tokenData.securityToken, tokenData.expiration);
    tokenData.securityToken = tokenRes;
  }
  return token;
}
